module.exports = __webpack_public_path__ + "img/Gamma3_pdf.be2e3164.png";